export default "__VITE_ASSET__JsfK7RUC__"